import { Component, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { IMetaData } from "src/app/interfaces";
import { LogClass } from "src/app/logger";

@LogClass()
@Component({
    selector: "circ-data",
    templateUrl: "./data.component.html",
    styleUrls: ["./data.component.scss"],
    standalone: false
})
export class DataComponent {
  @Input()
  @Output()
  public data: IMetaData;
  @Input()
  public formGroup: FormGroup;
}
